import PropTypes from "prop-types";
import React, { useState } from "react";
import "../../style/FilterGroup.css";

const FilterGroup = (
  { groupList,
    onSelect = null,
    className = null,
    selectedByDefault = 0,
    alwaysOneSelected = false,
    tabIndex = true,
  }) => {
  const [selectedGroup, setSelectedGroup] = useState(selectedByDefault ? selectedByDefault : null);

  const handleClick = (group) => {
    if (onSelect) {
      if (group.id !== selectedGroup) {
        setSelectedGroup(group.id);
        onSelect(group.id);
      } else {
        if (!alwaysOneSelected) {
          setSelectedGroup(null);
          onSelect(null);
        }
      }
    }
  };

  return (
    <ul className={`group-list ${className ? className : ``}${onSelect ? `` : " disabled"}`}>
      {groupList.map((group) => (
        <li key={group.id}>
          <button
            type="button"
            onClick={() => handleClick(group)}
            className={`filter-group-button${selectedGroup === group.id ? " selected" : ""}`}
            tabIndex={tabIndex?0:-1}
          >
            {`${group.name}`}
          </button>
        </li>
      ))}
    </ul>
  );
};

FilterGroup.propTypes = {
  groupList: PropTypes.array.isRequired,
  onSelect: PropTypes.func,
  className: PropTypes.string,
};

export default FilterGroup;
